import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import HomeFilter from './HomeFilter';
import FilterNav from './FilterNav';

const apiUrl = process.env.REACT_APP_API_URL;
let debounceTimeout: NodeJS.Timeout;
const homeUrl = process.env.REACT_APP_HOME_URL;

const TrendingCoins = ({ activeTab }) => {
  const navigate = useNavigate();
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    const fetchTrendingCoins = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/coins/trending`);
        const data = await response.json();
        setCoins(data);
        setError(null);
      } catch (error) {
        console.error('Error fetching trending coins:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTrendingCoins();
  }, []);

  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
    <>
    {path === '/trending-coins' && (
      <div className="toppagetitle">
        <div className="container">
          <div className="pagetitle">
            <h1>Trending Coins</h1>
          </div>
        </div>
      </div>
    )}
      <HomeFilter coins={coins} activeTab={activeTab} />
    </>
  );
};

export default TrendingCoins;